module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "notification-presentation row"
  }, [_c('span', [_vm._v("Agora, é possível gerenciar quais notificações e serviços quer receber por email. É simples, rápido e fácil. Basta selecionar das opções abaixo")])]), _vm._v(" "), _c('div', {
    staticClass: "notification-management-field row"
  }, [_c('accordion', {
    staticClass: "margin-t20",
    attrs: {
      "open": true
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('span', {
    staticClass: "notification-field-title"
  }, [_vm._v("Notificações de Conta")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "accordion-shipper notification-row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (notification.email),
        expression: "notification.email"
      }],
      attrs: {
        "type": "checkbox",
        "name": "2",
        "id": "2"
      },
      domProps: {
        "checked": Array.isArray(notification.email) ? _vm._i(notification.email, null) > -1 : (notification.email)
      },
      on: {
        "change": function($event) {
          var $$a = notification.email,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(notification, "email", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(notification, "email", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(notification, "email", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(notification.description) + "\n\t\t\t\t")])
  }), 0)], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-notification"
  }, [_vm._v("Notificações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-31518f94!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/notification.vue
// module id = 2085
// module chunks = 1